import { portRegEx } from 'widgets/integrations/FtpSettings/Form/consts/portRegEx';
import { protocolRegEx } from 'widgets/integrations/FtpSettings/Form/consts/protocolRegEx';
import * as yup from 'yup';

export const FtpSettingsValidationSchema = yup.object({
	host: yup
		.string()
		.required('integrations.validation.host_name.required')
		.max(50, 'integrations.validation.host_name.too_long'),
	port: yup
		.string()
		.required('integrations.validation.port.required')
		.matches(portRegEx, { message: 'integrations.validation.port.must_number' })
		.max(50, 'integrations.validation.port.too_long'),
	path: yup
		.string()
		.required('integrations.validation.path.required')
		.max(50, 'integrations.validation.path.too_long'),
	protocol: yup
		.string()
		.required('integrations.validation.protocol.required')
		.matches(protocolRegEx, { message: 'integrations.validation.protocol.must_be' })
		.max(8, 'integrations.validation.protocol.too_long'),
	username: yup
		.string()
		.required('integrations.validation.user_name.required')
		.max(50, 'integrations.validation.user_name.too_long'),
	password: yup
		.string()
		.required('integrations.validation.password.required')
		.max(50, 'integrations.validation.password.too_long'),
});
